import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { getVSIFileIcon } from "file-extension-icon-js";
import { trackPromise } from "react-promise-tracker";
import { Tree, Input, Spin, Modal, message, Button } from "antd";
import services from "../../services";
import "./styles.scss";
import {
  listarPastas,
  listarPastaFilha,
  moverPastas,
  historicoPastaAberta,
} from "../../services/http/pastaService";
import {
  registrarDownloadArquivo,
  registrarDownloadPasta,
  registrarVisualizacaoArquivo,
  registrarVisualizacaoPasta,
} from "../../services/http/dashboardService";
import { moverArquivo } from "../../services/http/arquivoServico";
import pastaSvg from "../../assets/icons/infoPasta.svg";
import iconNuvemArquivoSvg from "../../assets/icons/iconNuvemArquivo.svg";
import iconNuvemArquivoSvgSelect from "../../assets/icons/iconNuvemArquivoSelecionado.svg";
import {
  SearchOutlined,
  LoadingOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { showIniciais } from "../../helpers/showIniciais";
import ModalNovaPasta from "../ModalNovaPasta";
import { GoPlusCircle } from "react-icons/go";
import { CloseOutlined } from "@mui/icons-material";
import { getIconesExtensao } from "../../services/utils";
import { ReactComponent as PastaFechadaSvg } from "../../assets/icons/pastaFechadaMenu.svg";
import { ReactComponent as PastaSvg } from "../../assets/icons/pasta-menu.svg";
import { ReactComponent as PastaFechadaSvgSelecionado } from "../../assets/icons/pastaFechadaMenuSelecionado.svg";
import { ReactComponent as PastaSvgSelecionado } from "../../assets/icons/pasta-menu-selecionado.svg";
import PastaSelecionado from "../../assets/icons/pasta-menu-selecionado.svg";
import PastaIc from "../../assets/icons/pasta-menu.svg";
import lang from "../../assets/idioma/idiomas";
const initTreeData = [
  {
    title: "Nuvem de arquivos",
    key: "0/NuvemArquivo",
    icon: <img src={iconNuvemArquivoSvg} />,
  },
];

const ModalMoverArquivosPastas = ({
  openModal,
  closeModal,
  itemsSelecionadosMover,
  setShowTreeDataGaleria,
}) => {
  const { IdUser } = services.storage.getUser();
  const [expandedKeys, setExpandedKeyss] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [treeData, setTreeData] = useState(initTreeData);
  const [loading, setLoading] = useState(false);
  const [titulos, setTitulos] = useState([]);
  const [colarButtomLoading, setColarButtomLoading] = useState(false);
  const [modalNovaPasta, setModalNovaPasta] = useState(false);
  const [pastaDestino, setPastaDestino] = useState("");
  const [caminhoPastaDestino, setCaminhoPastaDestinho] = useState("");
  const [expadendAll, setExpanddAll] = useState(true);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [historicoSelecao, setHistoricoSelecao] = useState({
    pos: null,
    historico: [],
  });
  const [showTreeData, setShowTreeData] = useState(true);
  const { DirectoryTree } = Tree;
  let teste = [];

  const antIcon = (
    <LoadingOutlined
      style={{ display: "flex", justifyContent: "center", fontSize: 50 }}
      spin
    />
  );
  useEffect(() => {
    const updatedTreeData = [...treeData];
    const cloudNodeIndex = updatedTreeData.findIndex(
      (node) => node.key === "0/NuvemArquivo"
    );

    if (cloudNodeIndex !== -1) {
      const icon = selectedKeys.includes("0/NuvemArquivo")
        ? iconNuvemArquivoSvgSelect
        : iconNuvemArquivoSvg;
      updatedTreeData[cloudNodeIndex].icon = <img src={icon} />;
      setTreeData(updatedTreeData);
    }
  }, [selectedKeys]);
  const closeModalNovaPasta = (value) => {
    setModalNovaPasta(value);
  };

  const expanded = (expandedKeys, obj) => {
    if (obj?.node?.key != "0") {
      let testando = {};
      if (
        historicoSelecao.pos == null ||
        obj?.node?.pos.substring(4, 5) !=
          historicoSelecao?.historico[0]?.pos.substring(4, 5)
      ) {
        setHistoricoSelecao({ pos: null, historico: [] });
        testando = {
          pos: obj?.node?.pos,
          historico: [],
        };
      } else {
        testando = {
          historico: historicoSelecao.historico,
        };
      }

      let [idPastaSelecionada, nomePastaSelecionada] =
        obj?.node?.key.split("/");

      let novaPasta = {
        name: nomePastaSelecionada,
        id: idPastaSelecionada,
        pos: obj?.node?.pos,
      };

      if (
        !historicoSelecao?.historico?.some((x) => x.id == idPastaSelecionada)
      ) {
        testando.historico.push(novaPasta);
      }

      if (historicoSelecao.pos == null) {
        setHistoricoSelecao((prevState) => testando);
      }
    }
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeyss(expandedKeys);
    setAutoExpandParent(false);
  };

  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node.key === key) {
        return { ...node, children };
      }

      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        };
      }

      return node;
    });
  };

  const pastaSelecionada = (value) => {
    setSelectedKeys(value);
    setCaminhoPastaDestinho("");
    setPastaDestino("");
    if (value[0] !== "0") {
      let arrayPasta = String(value).split("/");
      setPastaDestino(arrayPasta[0]);
      trackPromise(
        historicoPastaAberta(arrayPasta[0])
          .then((res) => {
            if (!res.fail && res.data) {
              if (res.data?.length > 0) {
                let novoCaminho = "";

                for (let index = res.data.length - 1; index >= 0; index--) {
                  novoCaminho += `${res.data[index].name} > `;
                }

                novoCaminho += `${arrayPasta[1]}`;
                setCaminhoPastaDestinho(novoCaminho);
              } else {
                setCaminhoPastaDestinho(`${arrayPasta[1]}`);
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const loop = (data) =>
    data.map((item) => {
      const index = item.title.indexOf(searchValue);
      const beforeStr = item.title.substr(0, index);
      const afterStr = item.title.substr(index + searchValue.length);
      const title =
        index > -1 ? (
          <span>
            {beforeStr}
            <span className="site-tree-search-value">{searchValue}</span>
            {afterStr}
          </span>
        ) : (
          <span>{item.title}</span>
        );
      if (item.children) {
        return { title, key: item.key, children: loop(item.children) };
      }
      return {
        title,
        key: item.key,
      };
    });

  const onChange = (e) => {
    if (e.target.value != "") {
      const { value } = e.target;
      const expandedKeys = titulos
        .map((item) => {
          if (item.title.indexOf(value) > -1) {
            return getParentKey(item.key, treeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);

      setExpandedKeyss(expandedKeys);
      setSearchValue(value);
      setAutoExpandParent(true);
    } else {
      setExpandedKeyss([]);
      setSearchValue(e.target.value);
    }
  };

  const montarTitulos = (item) => {
    item.forEach((element) => {
      teste.push({
        title: element.title,
        key: element.key,
      });
      if (element?.children.length > 0) {
        montarTitulos(element?.children);
      }
    });

    return teste;
  };

  const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key;
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children);
        }
      }
    }
    return parentKey;
  };

  const moverPasta = (data, boleano) => {
    trackPromise(
      moverPastas(data)
        .then((res) => {
          if (!res.fail && res.data) {
            if (boleano) {
              message.success(lang.Movido_com_sucesso);
            }
            closeModal();
            setColarButtomLoading(false);
          } else {
            if (res.errors.message != undefined) {
              message.warning(res.errors.message);
            }
            setColarButtomLoading(false);
          }
        })
        .catch((error) => {
          message.error(error);
          setColarButtomLoading(false);
        })
    );
  };

  const moveArquivo = (data, boleano) => {
    trackPromise(
      moverArquivo(data)
        .then((res) => {
          if (!res.fail) {
            if (boleano) {
              message.success(lang.Movido_com_sucesso);
            }
            closeModal();
            setColarButtomLoading(false);
          } else {
            if (res.errors.message != undefined) {
              message.warning(res.errors.message);
            }
            setColarButtomLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setColarButtomLoading(false);
        })
    );
  };

  const submitMover = () => {
    itemsSelecionadosMover.forEach((item, index) => {
      setColarButtomLoading(true);
      if (item.tipo == 0) {
        if (pastaDestino == "0") {
          const data = {
            pastasIds: [item.id],
          };

          var boleano =
            itemsSelecionadosMover.length - 1 == index ? true : false;
          moverPasta(data, boleano);
        } else {
          const data = {
            pastasIds: [item.id],
            idPastaDestino: pastaDestino,
          };

          var boleano =
            itemsSelecionadosMover.length - 1 == index ? true : false;
          moverPasta(data, boleano);
        }
      } else {
        if (pastaDestino == "0") {
          const data = {
            idUsuario: IdUser,
            idArquivo: item.id,
          };

          var boleano =
            itemsSelecionadosMover.length - 1 == index ? true : false;
          moveArquivo(data, boleano);
        } else {
          const data = {
            idUsuario: IdUser,
            idArquivo: item.id,
            idPastaDestino: pastaDestino,
          };
          var boleano =
            itemsSelecionadosMover.length - 1 == index ? true : false;
          moveArquivo(data, boleano);
        }
      }

      setShowTreeDataGaleria(false);

      setTimeout(() => {
        setShowTreeDataGaleria(true);
      }, 2);
    });
  };

  const registrarVisualizacaoPastas = (idPasta) => {
    trackPromise(
      registrarVisualizacaoPasta(idPasta)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const OpenModalNovaPasta = () => {
    if (!pastaDestino) {
      message.info("Selecione apenas uma única pasta");
    } else {
      setModalNovaPasta(true);
    }
  };

  const preImagemArquivo = (item) => {
    const extensao = item.extensao ?? item.nome.split(".")[1];

    let nomeArquivo =
      !item.nome.includes(".") && extensao != null
        ? `${item.nome}.${extensao}`
        : item.nome;

    if (item.urlPreview) {
      return (
        <img
          src={item.urlPreview}
          style={{
            maxHeight: "1.5rem",
            maxWidth: "1.5rem",
            marginRight: "5px",
          }}
        />
      );
    } else {
      return (
        <img
          src={getIconesExtensao(extensao)}
          style={{
            maxHeight: "1.5rem",
            maxWidth: "1.5rem",
            marginRight: "5px",
          }}
        />
      );
    }
  };
  const formatNomePasta = (nome) => {
    if (nome.length > 20) {
      return nome.slice(0, 20) + "...";
    }
    return nome;
  };

  const onLoadData = ({ key, children }) =>
    new Promise((resolve) => {
      setLoading(true);
      if (key.split("/")[0] == "0") {
        trackPromise(
          listarPastas(IdUser, 1, 10000)
            .then((res) => {
              if (!res.fail && res.data) {
                let array = [];
                res.data.lista.forEach((element) => {
                  array.push({
                    title: formatNomePasta(element.nome),
                    key: `${element.id}/${element.nome}`,
                  });
                });

                setTreeData((origin) => updateTreeData(origin, key, array));
              }
              setLoading(false);
              resolve();
            })
            .catch((error) => {
              console.error(error);
            })
        );
      } else {
        setLoading(true);
        let [idPastaSelecionada, nomePastaSelecionada] = key.split("/");
        trackPromise(
          listarPastaFilha(idPastaSelecionada)
            .then((res) => {
              if (!res.fail && res.data) {
                let array = [];

                res.data.forEach((element) => {
                  if (element.tipo == 0) {
                    array.push({
                      title: formatNomePasta(element.nome),
                      key: `${element.id}/${element.nome}`,
                    });
                  }
                });
                setTreeData((origin) => updateTreeData(origin, key, array));
                registrarVisualizacaoPastas(idPastaSelecionada);
                setLoading(false);
                resolve();
              } else {
                resolve();
              }
            })
            .catch((error) => {
              console.error(error);
            })
        );
      }
    });
  const renderizarIcone = (props) => {
    const { isLeaf, expanded, selected } = props;

    let iconeAberto = <PastaFechadaSvg />;
    let iconeFechado = <PastaSvg />;

    if (selected) {
      iconeAberto = <PastaFechadaSvgSelecionado />;
      iconeFechado = <PastaSvgSelecionado />;
    }

    const icone = isLeaf ? null : expanded ? iconeAberto : iconeFechado;

    return icone;
  };

  return (
    <div>
      <Modal
        title={<span className="modal-title-novo ">{lang.Mover}</span>}
        visible={openModal}
        closable={false}
        className="modal-novo"
        // onCancel={closeModal}
        footer={[
          <div>
            <div className="row justify-content-center">
              <button
                onClick={() => OpenModalNovaPasta()}
                className="button-modal-novo mb-5"
              >
                <GoPlusCircle fontSize={20} className="mr-2" />{" "}
                {lang.Nova_pasta}
              </button>
            </div>

            <div className="buttons-finalizar-upload">
              <button
                onClick={closeModal}
                className="button-modal-novo"
                style={{ marginRight: "45px" }}
              >
                {lang.Cancelar}
              </button>
              <Button
                className="buttonConfirmar-modal-novo"
                onClick={() => submitMover()}
                loading={colarButtomLoading}
              >
                {colarButtomLoading ? lang.Movendo + "..." : lang.Mover}
              </Button>
            </div>
          </div>,
        ]}
      >
        <CloseOutlined onClick={closeModal} className="custom-close-icon" />
        <div>
          <div className="fundoModal">
            <div className="row espacoInterno">
              <div className="col-md-4 col-sm-4 col-xl-4 itensPastas">
                {" "}
                {lang.Itens_selecionados}:
              </div>
              <div className="col-md-8 col-sm-8 col-xl-8">
                <div className="row card-user-avatar">
                  {itemsSelecionadosMover.map((itemSelecionado) => {
                    return (
                      <div className="col-md-6 col-sm-6 col-xl-6 mt-2">
                        <span className="avatar-item">
                          {itemSelecionado.tipo == 0 ? (
                            <img
                              src={pastaSvg}
                              style={{ marginRight: "5px" }}
                            />
                          ) : (
                            preImagemArquivo(itemSelecionado)
                          )}
                          <span style={{ color: "#000", fontWeight: "bold" }}>
                            {showIniciais(itemSelecionado.nome)}
                          </span>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="row espacoInterno">
              <div className="col-md-4 col-sm-4 col-xl-4 iten-pastas-destino">
                {" "}
                {lang.Destino}:
              </div>
              <div className="col-md-8 col-sm-8 col-xl-8 mt-4">
                <div className="row card-user-avatar">
                  <div className="col-md-12 col-sm-12 col-xl-12">
                    <span className="avatar-item">
                      <img
                        src={iconNuvemArquivoSvg}
                        style={{ marginRight: "5px" }}
                      />
                      <span style={{ color: "#000", fontWeight: "bold" }}>
                        {"Nuvem de arquivos > " +
                          showIniciais(caminhoPastaDestino)}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row jus">
            <div
              style={{ padding: "0px" }}
              className="col-md-7 col-sm-7 col-xl-7 mb-3 mt-3"
            >
              <span style={{ color: "#BFBFBF" }}></span>
            </div>
          </div>
          {showTreeData && (
            <div className="espaceamentoInternoArvore">
              <span className="minhasPastas">{lang.Minhas_pastas}</span>
              <DirectoryTree
                onSelect={pastaSelecionada}
                defaultExpandAll={expadendAll}
                className="lista-pastas"
                loadData={onLoadData}
                treeData={treeData}
                onExpand={expanded}
                multiple
                switcherIcon={<DownOutlined />}
                icon={renderizarIcone}
              />
            </div>
          )}
        </div>
      </Modal>

      <ModalNovaPasta
        pastaDestino={pastaDestino}
        closeModal={closeModalNovaPasta}
        openModal={modalNovaPasta}
        setExpanddAll={setExpanddAll}
        setShowTreeData={setShowTreeData}
      />
    </div>
  );
};

export default ModalMoverArquivosPastas;
